import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useProjects } from "../../context/ProjectsContext";
import ClientCommandCenter from "../../components/dashboard/ClientCommandCenter";
import { dashboardProjectBase } from "../../utils/dashboardNavigation";

function projectMatches(project, key) {
  if (!project || !key) return false;
  return [project.slug, project.id, project._id]
    .filter(Boolean)
    .some((value) => String(value) === String(key));
}

export default function DashboardHomePage() {
  const { user } = useAuth();
  const { projectId = "" } = useParams();
  const {
    projects,
    activeProject,
    setActiveProject,
    projectCreation,
    loadProjects,
    loading,
    error,
  } = useProjects();
  const [requestedProjects, setRequestedProjects] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;
    loadProjects().finally(() => {
      if (mounted) setRequestedProjects(true);
    });
    return () => {
      mounted = false;
    };
  }, [loadProjects]);

  const routeProject = React.useMemo(
    () => projects.find((project) => projectMatches(project, projectId)) || null,
    [projects, projectId],
  );
  const effectiveProject = projectId
    ? (routeProject || (projectMatches(activeProject, projectId) ? activeProject : null))
    : activeProject;

  React.useEffect(() => {
    if (!projectId || !routeProject || projectMatches(activeProject, projectId)) return;
    setActiveProject(routeProject);
  }, [projectId, routeProject, activeProject, setActiveProject]);

  // /dashboard queda como Inicio global únicamente para cuentas sin proyecto.
  // Cuando existe uno activo, el Inicio canónico vive dentro del contexto del proyecto
  // para que la nueva navegación, permisos, campana y selector compartan la misma URL.
  if (!projectId && effectiveProject) {
    return <Navigate to={`${dashboardProjectBase(effectiveProject)}/inicio`} replace />;
  }

  if (projectId && requestedProjects && !loading && !effectiveProject && !error) {
    return <Navigate to="/dashboard/proyectos" replace />;
  }

  return (
    <ClientCommandCenter
      user={user}
      projects={projects}
      activeProject={effectiveProject}
      setActiveProject={setActiveProject}
      projectCreation={projectCreation}
      loading={loading || !requestedProjects}
      error={error}
    />
  );
}
